var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"trigger":"click","height":"100vh","interval":5000}},[_c('el-carousel-item',[_c('div',{staticClass:"banner-item"},[_c('oss-img',{attrs:{"src":"https://img.kakaclo.com/web-img/home/login/img2.png","width":960,"height":1080}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }